import React, { useEffect, useState } from "react";
import { fetchTours } from "../lib/api";
import { Users, ShieldCheck, Zap, Check, Loader2 } from "lucide-react";
import TourCard from "./TourCard";
import { useI18n } from "../lib/i18n";

const ToursSection = () => {
  const { t } = useI18n();
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTours()
      .then((data) => setTours(data))
      .catch(() => setTours([]))
      .finally(() => setLoading(false));
  }, []);

  const homepageTours = tours
    .filter((t) => t.show_on_homepage !== false)
    .sort((a, b) => (a.homepage_order || 0) - (b.homepage_order || 0));
  const featured = homepageTours.find((t) => t.label === "Most popular") || homepageTours[0];
  const rest = homepageTours.filter((t) => t !== featured).slice(0, 3);

  return (
    <section id="tours" className="section bg-[var(--ri-cream-2)]">
      <div className="container-x">
        <p className="eyebrow mb-3">{t("tours_eyebrow")}</p>
        <h2 className="font-serif-display text-[38px] md:text-[52px] leading-[1.05] max-w-[720px]">
          {t("tours_title")}
        </h2>

        <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-y-3 gap-x-8 max-w-[820px] text-[14px] text-[var(--ri-ink-soft)]">
          <span className="chip"><Users size={16} className="text-[var(--ri-red)]" /> {t("small_groups_max")}</span>
          <span className="chip"><ShieldCheck size={16} className="text-[var(--ri-red)]" /> {t("free_cancellation")}</span>
          <span className="chip"><Zap size={16} className="text-[var(--ri-red)]" /> {t("instant_confirmation")}</span>
          <span className="chip"><Check size={16} className="text-[var(--ri-red)]" /> {t("no_booking_fees")}</span>
        </div>

        {loading ? (
          <div className="flex justify-center py-24">
            <Loader2 className="animate-spin text-[var(--ri-red)]" size={32} />
          </div>
        ) : (
          <>
            {featured && (
              <div className="mt-12">
                <TourCard tour={featured} featured />
              </div>
            )}
            <div className="mt-8 grid md:grid-cols-3 gap-6">
              {rest.map((tour) => (
                <TourCard key={tour.id} tour={tour} />
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default ToursSection;
